import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

const HUBSPOT_PORTAL_ID = '20336610';

const SupportChat = () => {
  useEffect(() => {
    // Function to attempt opening the widget
    const tryOpenWidget = () => {
      if (window.HubSpotConversations && window.HubSpotConversations.widget) {
        window.HubSpotConversations.widget.open();
        return true;
      }
      return false;
    };

    // Try immediately
    if (tryOpenWidget()) return;

    // Load script if not present
    if (!document.getElementById('hs-script-loader')) {
      const script = document.createElement('script');
      script.id = 'hs-script-loader';
      script.src = `//js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    // Poll until ready
    const interval = setInterval(() => {
      if (tryOpenWidget()) {
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        backgroundColor: '#f5f5f5',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <CircularProgress size={60} sx={{ mb: 4, color: '#ff6b00' }} />
      <Typography
        variant="h4"
        sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}
      >
        Connecting to Support
      </Typography>
      <Typography variant="body1" sx={{ color: '#666', maxWidth: 400 }}>
        Please wait a moment while we load the chat widget. If it doesn't open
        automatically, look for the chat icon in the bottom right corner.
      </Typography>
    </Box>
  );
};

export default SupportChat;
